import React from 'react';
import '../Style.css';

const CaseStudy = () => {
  return (
    <>
      <div className="above-sp-case"></div>
      <div className="case-study-container">
        {/* Existing AAIR HVAC Section */}
        <section className="intro">
          <div className="study-text">
            <h1>AAIR HVAC</h1>
            <p className="description">
              <strong>Project Overview</strong><br />
              AAIR HVAC approached us with the goal of creating a modern, responsive, and user-friendly website to 
              showcase their HVAC services, increase customer inquiries, and establish credibility through online
              presence. The project involved full-cycle design and development—from wireframing in Figma to launching
              a fully functional WordPress website.
            </p>
            <a href="https://aairhvac.com" className="case-study-btn">Visit Website</a>
          </div>
          <div className="study-img">
            <div className="mockup-image">
              <img src="/Images/aairhvac-img.webp" alt="AAIR HVAC Website Mockup" />
            </div>
          </div>
        </section>

        <section className="grid-section">
          <div className="cd-way">
            <h2>Key Objectives</h2>
            <ul>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Craft a modern, responsive website tailored for the HVAC industry</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Improve user experience and lead generation through forms and popups</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Ensure SEO optimization for better search engine visibility</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Allow easy updates and scalability with WordPress and Elementor</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Integrate customer reviews and product/service filters</li>
            </ul>
          </div>
          <div className="role-list">
            <h2>My Role</h2>
            <ul>
              <li><img src="/Images/ux-reseracher.svg" width={40} alt="icon" /> UX Researcher</li>
              <li><img src="/Images/ui-ux.svg" width={40} alt="icon" /> UI/UX Designer</li>
              <li><img src="/Images/Wordpress-dev.svg" width={40} alt="icon" /> WordPress Developer</li>
              <li><img src="/Images/seo-dev.svg" width={40} alt="icon" /> SEO Specialist</li>
            </ul>
          </div>
        </section>

        <section className="grid-section">
          <div className="design-t-list">
            <h2>Design & Development</h2>
            <p><strong>UI/UX Design (Figma):</strong> Created a clean, professional layout with easy navigation, trust-building visuals, and mobile-first responsiveness.</p>
            <p><strong>WordPress Development:</strong> Built with Elementor for custom layouts, Contact Form 7 and Gravity Forms for lead generation, WooCommerce for product listings, and Filter Everything for dynamic filtering.</p>
            <p><strong>Additional Features:</strong> Integrated Popup Maker for conversions, Easy Accordion for FAQs, Google Reviews for credibility, and Yoast SEO for optimization.</p>
            <div className="duration">
              <h2>Project Duration</h2>
              <p>May 1st - May 15th, 2025</p>
            </div>
          </div>
          <div className="platforms-list">
            <h2>Tech Stack</h2>
            <table>
              <thead>
                <tr>
                  <th>Tool/Plugin</th>
                  <th>Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>WordPress</td><td>CMS</td></tr>
                <tr><td>Figma</td><td>UI/UX Design</td></tr>
                <tr><td>Elementor</td><td>Page Building</td></tr>
                <tr><td>Contact Form 7</td><td>Basic Forms</td></tr>
                <tr><td>Gravity Forms</td><td>Advanced Forms</td></tr>
                <tr><td>Popup Maker</td><td>Popups and CTAs</td></tr>
                <tr><td>Easy Accordion</td><td>Expandable Content</td></tr>
                <tr><td>WooCommerce</td><td>Product/Service Listings</td></tr>
                <tr><td>Filter Everything</td><td>Dynamic Filtering</td></tr>
                <tr><td>Google Reviews</td><td>Trust Signals</td></tr>
                <tr><td>Yoast SEO</td><td>Search Engine Optimization</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="grid-section">
          <div className="cd-way">
            <h2>Results</h2>
            <ul>
              <li>Increased lead generation through well-structured contact forms and CTAs</li>
              <li>Improved SEO rankings with fast load times and on-page practices</li>
              <li>Enhanced credibility with Google Reviews and professional layout</li>
              <li>Scalability through modular page structure</li>
            </ul>
          </div>
          <div className="role-list">
            <h2>Lessons Learned</h2>
            <ul>
              <li>Combining Contact Form 7 with Gravity Forms provided flexibility for forms</li>
              <li>Pre-planning user journeys in Figma reduced development time</li>
              <li>Elementor ecosystem ensured dynamic content and scalability</li>
            </ul>
          </div>
        </section>

        {/* New Justin Colón Books Section */}
        <section className="intro-book">
          <div className="study-text-book">
            <h1>Justin Colón Books</h1>
            <p className="description-book">
              <strong>Project Overview</strong><br />
              Justin Colón, a children’s book author and editor, needed a modern, warm, and engaging website to showcase his books, editorial services, and resources for writers. The goal was to create an inviting, easily navigable, and responsive website that reflects Justin’s brand and connects him with readers, clients, and the writing community.
            </p>
            <a href="https://justincolonbooks.com" className="case-study-btn-book">Visit Website</a>
          </div>
          <div className="study-img-book">
            <div className="mockup-image-book">
              <img src="/Images/app5.webp" alt="Justin Colón Books Website Mockup" />
            </div>
          </div>
        </section>

        <section className="grid-section-book">
          <div className="cd-way-book">
            <h2>Key Objectives</h2>
            <ul>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Design a visually engaging and brand-aligned website for a children's author</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Highlight editorial services and past client success stories</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Provide clear navigation and contact pathways for site visitors</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Enable simple content management through Elementor</li>
              <li><img src="/Images/check-icon.svg" alt="icon" /> Build trust and credibility using testimonials and a professional layout</li>
            </ul>
          </div>
          <div className="role-list-book">
            <h2>My Role</h2>
            <ul>
              <li><img src="/Images/ux-reseracher.svg" width={40} alt="icon" /> UX Researcher</li>
              <li><img src="/Images/ui-ux.svg" width={40} alt="icon" /> UI/UX Designer</li>
              <li><img src="/Images/Wordpress-dev.svg" width={40} alt="icon" /> WordPress Developer</li>
            </ul>
          </div>
        </section>

        <section className="grid-section-book">
          <div className="design-t-list-book">
            <h2>Design & Development</h2>
            <p><strong>UI/UX Design (Figma):</strong> Designed a whimsical yet professional interface with bright visuals, emphasizing Justin’s personality and mobile usability.</p>
            <p><strong>WordPress Development:</strong> Utilized Elementor and Ultimate Addons for Elementor (UAE) for customized, responsive pages, Testimonial Slider for client endorsements, and Contact Form 7 for inquiries.</p>
            <p><strong>Additional Features:</strong> Implemented animated testimonial sliders, optimized images, and accessibility best practices for color contrast and font sizing.</p>
            <div className="duration-book">
              <h2>Project Duration</h2>
              <p>April 1st - April 15th, 2025</p>
            </div>
          </div>
          <div className="platforms-list-book">
            <h2>Tech Stack</h2>
            <table>
              <thead>
                <tr>
                  <th>Tool/Plugin</th>
                  <th>Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>WordPress</td><td>CMS</td></tr>
                <tr><td>Figma</td><td>UI/UX Design</td></tr>
                <tr><td>Elementor</td><td>Page Building</td></tr>
                <tr><td>Ultimate Addons for Elementor</td><td>Enhanced Widgets & Design Features</td></tr>
                <tr><td>Testimonial Slider & Showcase</td><td>Displaying Testimonials</td></tr>
                <tr><td>Contact Form 7</td><td>Contact Form</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="grid-section-book-last">
          <div className="cd-way-book">
            <h2>Results</h2>
            <ul>
              <li>Improved visitor engagement and inquiries through clear navigation</li>
              <li>Enhanced credibility with professional testimonials</li>
              <li>Seamless mobile experience boosted usability and reach</li>
              <li>Brand-consistent design strengthened author identity</li>
            </ul>
          </div>
          <div className="role-list-book">
            <h2>Lessons Learned</h2>
            <ul>
              <li>UAE reduced the need for extra plugins with multifunctional widgets</li>
              <li>Elementor enabled fast visual feedback and client collaboration</li>
              <li>Testimonials significantly increased client conversion potential</li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default CaseStudy;